module.exports = __webpack_public_path__ + "static/media/edit.24515349.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/edit.svg
// module id = 396
// module chunks = 0